import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Image from '@client/components/image/Image';
import FooterItem from '@client/containers/appFrame/footer/footeritem/FooterItem';
import FooterSocialIcon from '@client/containers/appFrame/footer/footerSocialIcon/FooterSocialIcon';
import { strings } from '@client/localization/Localization';
import { categoryById, ROUTES } from '@client/pages/routes';
import { getLoadedCategories } from '@client/redux/dataFetching/fetchDataReducer';
import { COLORS } from '@client/shared/js/Colors';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import logo from '@client/shared/js/logo';
import styles from './footer.scss';

const footerTopMainEntries = [
  {
    title: `${strings.episodes}`,
    route: `${ROUTES.episodes}`,
  },
  {
    title: `${strings.series}`,
    route: `${ROUTES.series}`,
  },
  {
    divider: true,
  },
];

const footerBottomEntries = [
  {
    title: `${strings.aboutUs}`,
    route: `${ROUTES.about}`,
  },
  {
    title: `${strings.collaborate}`,
    route: `${ROUTES.collaborate}`,
  },
  {
    title: `${strings.contact}`,
    route: `${ROUTES.contact}`,
  },
];

const linkLevels = 'https://www.wearelevels.com';

class Footer extends PureComponent {
  render() {
    const { categories } = this.props;

    const nonEmptyCategories = categories.filter(
      (category) => category.episodeCount > 0
    );

    const topEntries = footerTopMainEntries.concat(
      nonEmptyCategories.map((category) => {
        return {
          title: category.title,
          route: categoryById(category.slug),
        };
      })
    );

    return (
      <div className={styles.footer}>
        <div className={styles.footerContentContainer}>
          <div className={styles.footerTopContent}>
            <Image className={styles.logo} src={logo.logo_black_2x} />
            <div className={styles.footerTopEntriesContainer}>
              <div className={styles.footerTopEntries}>
                {topEntries.map((entry, key) => (
                  <FooterItem
                    className={styles.footerItemTop}
                    key={key}
                    item={entry}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footerBottomContainer}>
          <div className={styles.footerBottomContent}>
            <p className={styles.factualsRights}>{strings.factualsRights}</p>
            <div className={styles.footerBottomEntries}>
              {footerBottomEntries.map((entry, index) => (
                <FooterItem
                  key={index}
                  item={entry}
                  className={styles.footerItemBottom}
                  color={COLORS.colorWhite}
                />
              ))}
              <div
                className={`${themeStyles.hideOnMobile} ${styles.producedByLevels}`}
              >
                <p className={styles.separator}>|</p>
                <p className={styles.producedBy}>{strings.producedBy} </p>
                <a target="_blank" rel="noopener noreferrer" href={linkLevels}>
                  <img className={styles.logoLevels} src={logo.levels} />
                </a>
              </div>
            </div>
            <div className={styles.socialIcons}>
              <FooterSocialIcon
                className={styles.footerSocialIcon}
                route={'https://www.instagram.com/watchfactuals/?hl=en'}
                socialName="instagram"
              />
              <FooterSocialIcon
                className={styles.footerSocialIcon}
                route={'https://www.facebook.com/FactualsCom/'}
                socialName="facebook"
              />
              <FooterSocialIcon
                className={styles.footerSocialIcon}
                route={
                  'https://www.linkedin.com/company/factuals-nordic/?viewAsMember=true'
                }
                socialName="linkedin"
              />
              <FooterSocialIcon
                className={styles.footerSocialIcon}
                route={
                  'https://www.youtube.com/channel/UC3IVjalqPzQda3FOuSdGnSA?view_as=subscriber'
                }
                socialName="you-tube"
              />
            </div>
            <p className={styles.factualsRightsMobile}>
              {strings.factualsRights}
            </p>
            <div
              className={`${themeStyles.hideOnDesktop} ${styles.producedByLevels}`}
            >
              <p className={styles.producedBy}>{strings.producedBy} </p>
              <a target="_blank" rel="noopener noreferrer" href={linkLevels}>
                <img className={styles.logoLevels} src={logo.levels} />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Footer.propTypes = {
  location: PropTypes.object,
  categories: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    categories: getLoadedCategories(state),
  };
}

export default connect(mapStateToProps)(withRouter(Footer));
